module.exports = __webpack_public_path__ + "img/leagueoflegends-cover.a004f6c1.jpg";